import React from 'react';
import Modal from "react-bootstrap/Modal";
import { Row, Col, Container } from "react-bootstrap";
import membershipImg from "../Patient/patient2.jpg";
import styles from "./membership.module.scss";
import Image from "../../common/lazyLoadImage/image";
const ViewMemberModal = ({ viewModal, setViewModal, membershipData }) => {
    return(
     <>
     <Modal show={viewModal} onHide={() => setViewModal(false)} size={"xl"} className={styles["modal"]}>
        <Modal.Header closeButton className={styles["modal-header"]}>
          <Modal.Title className={styles["modal-title"]}>Membership Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles["modal-body"]}>
        <Container className={styles["membership-container"]}>
        <Row className={styles["membership-row"]}>
          <Col lg={8} className={styles["membership-col"]}>
          <div className="profile">
             <div className="staff">
              <Image src={membershipImg} alt="" />
             </div>
             <div className="staf-info">
              <div>
                <span className="font-w600">Name:</span>
                <h2 className="fs-18">{membershipData?.name}</h2>
                <div>
                <span className="font-w600">Discount Percentage:</span>
                <span className="fs-17">{membershipData?.discountPercentage}</span>
                </div>
               </div>
            </div>
          </div>
          </Col>
        </Row>
           </Container>
            </Modal.Body>
         </Modal>

     </>
    );
};
export default ViewMemberModal;